import React from "react";
import "./blogs.css";


const Ayush_Dwivedi = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src="placement-postulates/dp/Ayush-Dwidevi.jpg"
            style={{ height: "315px", width: "90%" }}
            alt="ayush"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Ayush Dwivedi </h2>
            <small>Piramal Finance</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction : </h3>
            <p>
              Hello everyone, I am Ayush Dwivedi currently a Final Year
              Undergraduate in the Department of Civil Engineering at IIT
              Kanpur. I got placed as SDE (Software Development Engineer) at
              Piramal Finance and will be joining in the upcoming summers. Many
              of you must be knowing me as your Department Academic Mentor.
              Through this postulate, I would like to take you to my internship
              and placement journey, the challenges which I faced and most
              importantly how can one grab a good placement offer by doing smart
              work.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>THE INTERNSHIP HUSTLE </h3>
            <p>
              When I entered the college, I was determined for the UPSC
              examination and prepared for it for the first three semesters with
              great dedication. In the 4th semester, during lockdown I decided
              to give coding a try after I came to know about the internships at
              campus. I was a bit late as many of my batchmates were already
              doing great in Competitive programming and had started preparing
              for the Internships from the very start, but it’s never too late
              to make a new start.Talking about my academics,I had a very poor
              Cpi of 7.2 during internship session as I didn’t care much about
              it due the UPSC preparation. I approached many seniors regarding
              the internship preparation and finally started with Interviewbit,
              which I consider to be a great platform to start with, as it has
              all the required concepts in a sequential order. Initially, I
              considered various youtube channels like mycodeschool, aditya
              verma etc to strengthen my fundamentals in DSA. After solving a
              decent number of questions on interviewbit I started searching for
              projects. Honestly speaking I would recommend not to go for too
              many projects,3 or 4 good projects based on development or ML or
              whatever your field of interest are enough. I had 3 self-made ML
              projects which got me into Data science as well as SDE
              interviews.Talking about the phase-1 of internship, many companies
              were biased for top branches and CPI, so I had to suffer. After
              giving more than 30 coding tests, I got shortlisted for 2-3
              interviews which I skipped, in search of a better internship offer
              ahead(Strictly don’t do this). No offer left me with hopelessness
              and confusion. I didn’t register myself for the 2nd phase and
              started searching for off campus opportunities via Linkedin
              Connections. I was lucky enough to get an interview call from EXL
              SERVICE. There were 2 rounds of interviews (Coding+HR). Finally, I
              got an internship as a decision analytics in EXL SERVICE. So,
              don’t lose hope if you don’t get any Offer, just keep going.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Ayush/1.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>PLACEMENT PLANNING </h3>
            <p>
              I started my placement preparation from the summer onwards i.e
              JUNE 2022 since my main focus in the 6th semester was getting an
              internship. I had almost 4 months to prepare for placements as
              companies coding rounds mainly starts from october onwards(A few
              in september) which I think is a sufficient time. I had made up my
              mind to target SDE/ML/Analytics roles for placements. I would
              share some of my resources and experience during the preparation.
            </p>
          </div>
        </div>
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Coding Preparation(Journey) : </h3>
            <p>
              I had already done interviewbit for my internship preparation so I
              decided to do leetcode and gfg. I would recommend to solve more
              medium level problems on leetcode as most companies coding rounds
              are at that level. I watched playlist for topics like tree, graph,
              dp which are tricky and most asked in interviews on Youtube.
              Beside this I used to give contests on Codeforces which will
              helped me to solve greedy problems and improve my problem solving
              ability.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Ayush/5.jpg"
        />

        <br />
        <br />
        <br />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Aptitude/Probability/Puzzles : </h3>
            <p>
              We all are good at aptitude so just try solving aptitude problems
              from previous year CAT papers. For probability, I used prepleaf
              video and solved some questions from “Fifty Challenging Problems”
              but I won’t recommend it as the questions in this book are not
              usually asked and are difficult. Coming to puzzles, they are most
              important for interviews.The best source for puzzles is “Brain
              steller”. There are around 60-70 easy to medium level problems on
              Brain steller.
            </p>
            <br />
            <br />
            <p>
              <strong>HR : </strong> Most of us are uncomfortable in expressing
              ourselves in English in interviews. I think these things improve
              with time, so try to interact with your friends in English. Don’t
              hesitate And even try to correct each other when wrong.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Ayush/3.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>SQL/CS fundamentals : </h3>
            <p>
              Few companies ask SQL queries and MCQs on CS fundamentals such as
              OOP, DBMS, OS in their initial rounds. One can watch youtube
              tutorials on SQL and try practising queries on interviewbit.
            </p>
            <br />
            <p>
              <strong>CPI</strong> doesn’t matter is a myth, a good CPI will
              always provide you an edge over others. You will easily get
              shortlisted for many tests and have a good chance in walk-in
              interviews. Try to maintain a 7.5+ CPI and you will be eligible
              for almost every test. I was not shortlisted for many companies
              where I had solved almost all questions in the coding round, just
              because of low CPI or branch cutoff. Don’t get frustrated but
              rather focus on the upcoming companies. Try to give all the tests
              without worrying about the chances of getting shortlisted. Be
              confident because there will be a lot of opportunities. Believe in
              yourself and you will definitely get shortlisted. Even if you are
              not shortlisted in any company, there are still waiting lists and
              walk-in interviews for companies. <br />
              After the hectic placement process of 3 months, finally I was
              shortlisted in the company <strong>Piramal Finance </strong>and
              hoped to get my name in waiting list of a few more companies.
            </p>
          </div>
        </div>
        <br />
        <br />
        <div className="row blog-row">
          <div className="col-md-12">
            <h4>Day1 : </h4>
            <p>
              I was expecting interview calls from Sprinkler(DS), Navi etc as I
              had solved almost all the questions but nothing happened. Walk-in
              interviews had already started for a few companies in the 2nd slot
              but I ignored them as I had a shortlist for the next day.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src="placement-postulates/blogs/Ayush/4.jpg"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h4>Day2 : </h4>
            <p>
              The most awaited day of my placement journey had finally arrived
              and I had only one shortlist in my hand which I had to crack
              anyhow. I got a call from coco to be prepared for my interview and
              I immediately dressed up and ran towards HALL-12. I didn’t know
              that I was the first to be interviewed. Finally the interview
              started.
              <br />
              <br />
              <strong>Round1(Technical-25-30 mins) :</strong> I was asked to
              solve and explain 3 coding questions on paper. Questions were
              moderate, based on graph, modified binary search and merge sort.
              The interview went well and I was able to answer all the
              questions. I was confident to get a call for round 2. Try to be
              interactive with the interviewer and explain whatever you are
              thinking at the time of writing code.
              <br />
              <br />
              <strong>Round2(Technical-25-30min) :</strong> I got a call for
              round 2 immediately after the round1. I was expecting the
              interview to be resume-based but to my very surprise, the first
              question was a coding problem statement and I was asked to find
              the most optimal solution. The question was moderately hard based
              on greedy. I took some time but was successful in answering it.
              Then comes the resume part, questions were asked based on my
              internship and since the interviewer was a developer he didn’t ask
              much from my ML projects. Some basic questions were also asked on
              my POR’s. Overall the interview went well.
              <br />
              <br />
              <strong>Round3(HR-15 min) :</strong> Basic HR questions and
              discussion on women empowerment and opportunities.
              <br />
              Offered!
            </p>
          </div>
        </div>

        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Ayush/2.jpg"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>LIFE BEYOND CAMPUS PLACEMENTS</h3>
            <p>
              There is a life beyond placements and internships, don’t get
              hopeless or frustrated in this Journey. There will be exhausting
              moments when you will think of giving up on tests or think to
              change your career option several times but believe me you all
              will succeed. Be focused and have a clarity about what you want to
              achieve as it will help you make the right decisions throughout
              your college life. Build genuine relationships with professors,
              alumni, and professionals in your field. They can provide valuable
              guidance, mentorship, and potential job Opportunities. College is
              a transformative period of your life, so make sure to enjoy the
              journey.
              <br />
              Placements can be stressful so don’t forget to relax, chill and
              help your wingies as they will be only one standing during your
              tough times.
            </p>
          </div>
        </div>

        <p>
          <ul>
            <li>
              <b>Resume:</b>{" "}
              <a
                href="https://drive.google.com/file/d/1qMomU3yzSQTYWtq3Zkhc5FW_4tB3SJQk/view?usp=drivesdk"
                className="resume-link"
              >
                [View Resume]
              </a>
            </li>
          </ul>
        </p>
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  );
};

export default Ayush_Dwivedi ;
